import {
    SET_CARDS,
    SET_TABLE,
    SET_PAYMENTMETHON_LIST
} from "@/views/recognition/store/types/types.js";

const mutations = {
    [SET_CARDS]: (state, payload) => state.cards = payload,
    [SET_TABLE]: (state, payload) => state.table = payload,
    [SET_PAYMENTMETHON_LIST]: (state, payload) => state.typePaymentMethon = payload
};

export default mutations